import { AttachmentRejectedError } from '@tempo-io/fim3-dto';

type ServerError = { response?: { data?: { message?: unknown; error?: unknown } } };

export const getServerErrorReason = (error: unknown): string | undefined => {
  const data = (error as ServerError | undefined)?.response?.data;
  if (data?.error !== AttachmentRejectedError) return undefined;
  return typeof data.message === 'string' && data.message !== '' ? data.message : undefined;
};
